module.exports = __webpack_public_path__ + "img/toplupe-logo.e1c8a05.png";